// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"0d6029c1","315":"6af4e807","643":"0e02bb73","734":"a484f421","810":"db442c77"}[chunkId] + ".chunk.js";
};